import $ from 'jquery';

import DDTemplates from './DDTemplates';
import Drupal from './Drupal';
import Header from './Header';
import Sticky from './Sticky';
import Gallery from './Gallery';
import Toolbar from './Toolbar';
import Menu from './Menu';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
import Search from './Search';
import Columns from './Columns';
import AccordionWrap from './AccordionWrap';
import AccordionFix from './AccordionFix';
import AccordionContainer from './AccordionContainer';
import Placeholder from './Placeholder';
import Banner from './Banner';
import BackgroundImage from './BackgroundImage';
import ResourcesSelect from './ResourcesSelect';
import RemoveLink from './RemoveLink';
import SliderSponsors from './Slider.Sponsors';
import Events from './Events';
import BrowserCheck from './BrowserCheck';
// import HomeCaptions from './HomeCaptions';
import ResourcesTemplate from './ResourcesTemplate';
import SelectAlpha from './SelectAlpha';

// Add the theme behaviors
Drupal.behavior((context) => {
  // Helpers
  const $body = $(document.body, context);

  // DD Template Behaviors
  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Get browser and version
  $body.each((i, element) => {
    if (!element.browserCheck) {
      element.browserCheck = new BrowserCheck(element);
    }
  });

  // Fix our damn menus from displaying orphaned children
  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Sticky sidebars
  $('.page-sidebar', context).each((i, element) => {
    if (!element.Sticky) {
      element.Sticky = new Sticky(element);
    }
  });

  // Main/Primary Site Navigation
  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.Menu) {
      // element.Menu = new Menu(element);
      element.Menu = new Menu(element);
    }
  });

  // Controls the states of the menu and search states
  $('.toolbar', context).each((i, element) => {
    if (!element.Toolbar) {
      element.Toolbar = new Toolbar(element);
    }
  });

  // Clone search to flyout
  $('.dd-search', context).each((i, element) => {
    if (!element.search) {
      element.search = new Search(element);
    }
  });

  // Controls the page overlay display
  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Fixed Header using Headroom.js
  $('.headroom', context).each((i, element) => {
    if (!element.Header) {
      element.Header = new Header(element);
      $(element).addClass('ready');
    }
  });

  // Smart Footer
  $('.page-footer', context).each((i, element) => {
    const $footprint = $('.footprint', context);
    if (!element.SmartFooter && $footprint.length) {
      setTimeout(() => {
        element.SmartFooter = new SmartFooter(element, $footprint);
      }, 500);
    }
  });

  // Background images
  $('.banner', context).each((i, element) => {
    if (!element.banner) {
      // Adds .has-banner class to body if banner exists
      element.banner = new Banner(element);
      element.banner = new BackgroundImage(element);
    }
  });
  $('.home-news-image .views-row, .home-news .views-row, .home-spotlight .views-row', context).each((i, element) => {
    if (!element.banner) {
      element.banner = new BackgroundImage(element, {
        destSelector: '.field-image',
      });
    }
    if ($body.hasClass('front')) {
      $body.find('.page-top').addClass('ready');
      $body.find('.content-after').addClass('ready');
    }
  });

  // Columns
  $('.footerlinks', context).each((i, element) => {
    if (!element.columns) {
      element.columns = new Columns(element, {
        columns: 2,
        item: '.views-row',
        parent: '.view-content',
        blockName: 'footerlinks',
      });
    }
  });
  // $('.home-resources', context).each((i, element) => {
  //   if (!element.resourcesCols) {
  //     $(element).find('.link-read-more').remove();
  //     element.resourcesCols = new Columns(element, {
  //       columns: 2,
  //       item: '.link',
  //       parent: 'ul.links',
  //       blockName: 'home-resources',
  //     });
  //   }
  // });
  $('.home-events', context).each((i, element) => {
    if (!element.resourcesCols) {
      element.resourcesCols = new Columns(element, {
        columns: 2,
        item: '.views-row',
        parent: '.view-content',
        blockName: 'home-events',
      });
    }
  });

  // Upcoming Events
  $('#block-views-calendar_feed-block_1', context).each((i, element) => {
    if (!element.Events) {
      element.Events = new Events(element);
    }
  });

  // Term Navigation
  $('.term-nav', context).each((i, element) => {
    if (!element.TermNavigation) {
      element.TermNavigation = new TermNavigation(element);
    }
  });

  // Photo Galleries
  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.Gallery) {
      element.Gallery = new Gallery(element);
    }
  });

  // Wraps each accordion element
  $('.accordion-heading', context).each((i, element) => {
    if (!element.accordionWrap) {
      element.accordionWrap = new AccordionWrap(element);
      element.accordionWrap = new AccordionFix(element);
    }
  });

  // Wraps each accordion in a container
  $('.node-content', context).each((i, element) => {
    if (!element.accordionContainer) {
      setTimeout(() => {
        element.accordionContainer = new AccordionContainer(element);
      }, 300);
    }
  });

  // Set placeholder of textfield using label
  $('.pods .type-textfield', context).each((i, element) => {
    if (!element.placeholder) {
      element.placeholder = new Placeholder(element, {
        trim: true,
      });
    }
  });

  // Caption clone and placement on certain homepage elements
  // $('.hero .views-row', context).each((i, element) => {
  //   if (!element.heroCaptions) {
  //     element.heroCaptions = new HomeCaptions(element);
  //   }
  // });
  // $('.home-news-image .views-row', context).each((i, element) => {
  //   if (!element.newsCaptions) {
  //     element.newsCaptions = new HomeCaptions(element, {
  //       newParent: '.content-after',
  //     });
  //   }
  // });

  // Remove link from .node-header
  $('.home-spotlight .views-row, .home-resources .views-row', context).each((i, element) => {
    if (!element.removeLink) {
      element.removeLink = new RemoveLink(element);
    }
  });

  // Calendar of Events View
  $('.calendar-feed', context).each((i, element) => {
    if (!element.CalendarFeed) {
      element.CalendarFeed = new CalendarFeed(element, {
        useFilters: true,
        filters: {
          'CAPIO Calendar': 0,
          'Partner Calendar': 295,
          'All Events': 2,
        },
      });
    }
  });

  // Medical services dropdown
  $('.home-resources', context).each((i, element) => {
    // Creates a select box from all of the related links.
    if (!element.filterSelect) {
      element.filterSelect = new ResourcesSelect(element, {
        placeholder: 'Quicklinks',
      });
    }
  });

  // Calendar of Events View
  $('.home-sponsors .view-content', context).each((i, element) => {
    if (!element.sliderSponsors) {
      element.sliderSponsors = new SliderSponsors(element);
    }
  });

  // Resources Template
  $('.view-member-resource-search', context).each((i, element) => {
    if (!element.resourcesTemplate) {
      element.resourcesTemplate = new ResourcesTemplate(element);
    }
  });

  // Alphabetize select lists
  $('#edit-tid, #edit-field-profiles-nid-1', context).each((i, element) => {
    if (!element.selectAlpha) {
      element.selectAlpha = new SelectAlpha(element);
    }
  });

  $body.addClass('instant');
  setTimeout(() => {
    $body.addClass('delayed');
  }, 500);

  // Add Sitemap output using the digitaldcore.js function
  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }
});
